import { useEffect, useState } from "react";
import { Col, Container, Row, Spinner, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../App";
import ScrollTopButton from "../ScrollTop";
import SidebarProfile from "../SidebarProfile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilm, faClock, faEye, faCalendar, faPlay } from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-paginate";
import '../../styles/profile.css';
import BrianAnimated from "../BrainAnimated";
import StonesLoader from "../Stones";
import BinocularsLoader from "../BinocularsLoader";

function ProfileVideos({ style }) {
    const [videos, setVideos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9; // 3 cards per row * 3 rows
        const [isPagingLoading, setIsPagingLoading] = useState(false);

    useEffect(() => {
  window.scrollTo(0, 0);

  const getVideosData = async () => {
    setIsLoading(true);

    const token = localStorage.getItem('token');
    const delay = new Promise(resolve => setTimeout(resolve, 2000)); // ⏱️ تأخير 3 ثوانٍ
    const request = axios.get(`${BASE_URL}/api/homework/videos`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    try {
      const [response] = await Promise.all([request, delay]);
      setVideos(response.data.data.filter(video => video !== null));
    } catch (error) {
      console.error("Failed to fetch videos data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  getVideosData();
}, []);


    function formatDate(dateString) {
        try {
            const date = new Date(dateString);
            const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC', numberingSystem: 'arab' };
            const formatter = new Intl.DateTimeFormat('ar-EG', options);
            return formatter.format(date);
        } catch (e) {
            return '';
        }
    }
    
   const handlePageClick = ({ selected }) => {
        setIsPagingLoading(true);
        setTimeout(() => {
            setCurrentPage(selected);
            setIsPagingLoading(false);
        }, 300);
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = videos.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(videos.length / itemsPerPage);
    
    if (isLoading) {
         return (
 <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
        <BrianAnimated style={style} />
        </div>
      </div>
    );
    }

    return (
        <>
            <div className={`profile-page ${style ? 'dark-mode' : ''}`}>
                <SidebarProfile />
                <main className="profile-main-content">
                    <Container fluid>
                        <div className="page-header">
                            <div className="header-icon-wrapper">
                                <FontAwesomeIcon icon={faFilm} />
                            </div>
                            <div className="header-text">
                                <h1>فيديوهات الواجبات</h1>
                                <p>شاهد فيديوهات حل الواجبات للمراجعة والتعلم.</p>
                            </div>
                        </div>
                        <Row>
                            <Col xs={12}>
                                {videos.length > 0 ? (
                                    <div className="cards-container-wrapper">
                                        {isPagingLoading && (
                                            <div className="cards-loading-overlay">
                                                <Spinner animation="border" variant={style ? 'light' : 'danger'} />
                                            </div>
                                        )}
                                        <Row className="video-cards-row">
                                            {currentItems.map((item, index) => (
                                                <Col key={item.id} lg={4} md={6} sm={12} className="mb-4">
                                                    <Card className={`video-card ${style ? 'dark-mode' : ''}`}>
                                                        <Card.Body>
                                                            <div className="card-header-section">
                                                                <h5 className="card-title">{item.title}</h5>
                                                                <div className="video-badge">
                                                                    <FontAwesomeIcon icon={faPlay} />
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="card-stats">
                                                                <div className="stat-item">
                                                                    <FontAwesomeIcon icon={faClock} className="stat-icon" />
                                                                    <div className="stat-content">
                                                                        <span className="stat-label">مدة الفيديو</span>
                                                                        <span className="stat-value">{item.video_dauration} دقيقة</span>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="stat-item">
                                                                    <FontAwesomeIcon icon={faEye} className="stat-icon" />
                                                                    <div className="stat-content">
                                                                        <span className="stat-label">عدد المشاهدات</span>
                                                                        <span className="stat-value">{item.noviews}</span>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="stat-item">
                                                                    <FontAwesomeIcon icon={faCalendar} className="stat-icon" />
                                                                    <div className="stat-content">
                                                                        <span className="stat-label">تاريخ الإضافة</span>
                                                                        <span className="stat-value">{formatDate(item.created_at)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="card-action">
                                                                <Link to={`/videohomework/${item.id}`} className="action-btn-card view">
                                                                    <FontAwesomeIcon icon={faPlay} />
                                                                    مشاهدة الفيديو
                                                                </Link>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                        
                                        <ReactPaginate
                                            previousLabel={'السابق'}
                                            nextLabel={'التالي'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination-container'}
                                            pageLinkClassName={'pagination-link'}
                                            previousLinkClassName={'pagination-link prev-next'}
                                            nextLinkClassName={'pagination-link prev-next'}
                                            breakLinkClassName={'pagination-link'}
                                            activeClassName={'pagination-active'}
                                            disabledClassName={'pagination-disabled'}
                                        />
                                    </div>
                                ) : (
                                     <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
                                        <h2> لسه مفيش اي فيديوهات اتفحت ليك </h2>
                                        <p>     سيتم ابلاغك في حين فتح فيديوهات ليك !   </p>
</div>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </main>
            </div>
            <ScrollTopButton />
        </>
    );
}

export default ProfileVideos;